import { render } from "./ai-settings.vue?vue&type=template&id=615185cc"
import script from "./ai-settings.vue?vue&type=script&lang=js"
export * from "./ai-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__